import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from "react-router-dom";
import QRCode from 'react-qr-code';
import { SuccessContent, Total } from './style';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FaCopy, FaCheckCircle } from 'react-icons/fa';
import { useDate } from "../../../hooks/useDate";
import { toast } from "react-toastify";
import { AuthContext } from "../../../context/Auth/AuthContext";
import { i18n } from '../../../translate/i18n';

function CheckoutSuccess(props) {

  const { pix } = props;
  const [pixString,] = useState(pix.qrcode.qrcode);
  const [copied, setCopied] = useState(false);
  const history = useHistory();
  //   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);


  const { dateToClient } = useDate();

  useEffect(() => {
    const companyId = user.companyId;
    if (companyId) {
      // const socket = socketManager.GetSocket();

      const onCompanyPayment = (data) => {

        if (data.action === "CONCLUIDA") {
          toast.success(i18n.t("checkout.success.licenseRenewed", { date: dateToClient(data.company.dueDate) }));
          setTimeout(() => {
            history.push("/");
          }, 4000);
        }
      }

      socket.on(`company-${companyId}-payment`, onCompanyPayment);

      return () => {
        socket.off(`company-${companyId}-payment`, onCompanyPayment);
      }
    }
  }, [socket]);

  const handleCopyQR = () => {
    setTimeout(() => {
      setCopied(false);
    }, 1 * 1000);
    setCopied(true);
  };

  const getNumberLocale = () => {
    const l = String(i18n.language || "").toLowerCase();
    if (l.startsWith("pt")) return "pt-BR";
    if (l.startsWith("en")) return "en-US";
    if (l.startsWith("fr")) return "fr-FR";
    if (l.startsWith("it")) return "it-IT";
    return "es-ES";
  };

  const formatBRL = (value) => {
    const locale = getNumberLocale();
    const amount = Number(value || 0);
    return amount.toLocaleString(locale, { style: "currency", currency: "BRL" });
  };

  return (
    <React.Fragment>
      <Total>
        <span>{i18n.t("checkout.success.total")}</span>
        <strong>{formatBRL(pix.valor?.original)}</strong>
      </Total>
      <SuccessContent>
        <QRCode value={pixString} />
        <CopyToClipboard text={pixString} onCopy={handleCopyQR}>
          <button className="copy-button" type="button">
            {copied ? (
              <>
                <span>{i18n.t("common.copied")}</span>
                <FaCheckCircle size={18} />
              </>
            ) : (
              <>
                <span>{i18n.t("checkout.success.copyQrCode")}</span>
                <FaCopy size={18} />
              </>
            )}
          </button>
        </CopyToClipboard>
        <span>
          {i18n.t("checkout.success.instructions")}
        </span>
      </SuccessContent>
    </React.Fragment>
  );
}

export default CheckoutSuccess;
